import React, {useState} from 'react';
import './App.css';
import 'antd/dist/antd.css';

import {Layout} from 'antd';
import Uploader from "../uploader/Uploader";
import UrlInputSource from "../uploader/UrlInputSource";
import Exif from "../exif/Exif";
import exifImg from '../exif.png';

const {Content} = Layout;

const App = () => {
    const [exifInfo, setExifInfo] = useState();


    return (
        <Layout className="app-container">
            <Content className="app-content">
                <div className="container">
                    <div className="exif-logo-container">
                        <img alt="Exif OSINT tool" src={exifImg}/>
                        <h3 className="tool-info">Part of the <span onClick={() => {
                            window.open('https://osint-tool.com', '_blank')
                        }}>OSINT-tool</span> suite of tools</h3>
                    </div>
                    {exifInfo && exifInfo.text && <Exif exifInfo={exifInfo}
                                                        onClose={() => setExifInfo(undefined)}/>}
                    <React.Fragment>
                        <UrlInputSource onExifInfo={(info) => setExifInfo(info)}/>
                        <Uploader onExifInfo={(info) => setExifInfo(info)}/>
                        <h3 className="file-info">Files are kept momentarily in memory during the request, and never even reaches a hard drive.</h3>
                    </React.Fragment>
                </div>
            </Content>
        </Layout>
    );
}

export default App;



// WEBPACK FOOTER //
// ./src/app/App.js